import React from "react";
import Wprr from "wprr";

export default class EditMixProducts extends Wprr.BaseObject {
	
	_construct() {
		super._construct();
		
		Wprr.development_updateFullTreeOnInjection = false;
		
		this._elementTreeItem.addSingleLink("operation", null);
		this._elementTreeItem.getLinks("selectedItems");
		
		let loader = this._elementTreeItem.createNode("loader", "loadDataRange");
		
		let detailsLoader = this._elementTreeItem.addNode("detailsLoader", new Wprr.utils.data.nodes.LoadAdditionalItems());
		detailsLoader.item.setValue("url", this.getWprrUrl("range/?select=idSelection,anyStatus&encode=fields,postStatus,postTitle&ids={ids}", "wprrData"));
		detailsLoader.item.getLinks("ids").input(loader.item.getLinks("items"));
		
		this._elementTreeItem.getValueSource("loaded").input(detailsLoader.item.getValueSource("loaded"));
		
		let activeList = this._elementTreeItem.addNode("activeList", new Wprr.utils.data.multitypeitems.controllers.list.ActiveList());
		activeList.item.setValue("activateWhenAdded", false);
		activeList.item.getLinks("items").input(this._elementTreeItem.getLinks("items"));
		
		this._elementTreeItem.getLinks("rows").input(activeList.item.getLinks("rows"));
		this._elementTreeItem.getLinks("selectedItems").input(activeList.item.getLinks("activeItems"));
		
		let filterItem = this._elementTreeItem.group.createInternalItem();
		let filteredList = Wprr.utils.data.multitypeitems.controllers.list.FilteredList.create(filterItem);
		filterItem.getType("all").input(this._elementTreeItem.getType("rows"));
		
		
		//let activeContractFilterItem = filteredList.addInArrayMatch("forItem.linkedItem.active.value", [true]);
		//this._elementTreeItem.addSingleLink("activeContractFilter", activeContractFilterItem.id);
		
		
		let searchFilterItem = filteredList.addFieldSearch("forItem.linkedItem.title.value");
		this._elementTreeItem.addSingleLink("searchFilter", searchFilterItem.id);
		
		//searchFilterItem.setValue("searchValue", "");
		
		let sort = Wprr.utils.data.multitypeitems.controllers.list.SortedList.create(this._elementTreeItem.group.createInternalItem());
		{
			let sortPartItem = sort.addFieldSort("forItem.linkedItem.title.value");
		}
		
		sort.item.getType("all").input(filterItem.getType("filtered"));
		
		this._elementTreeItem.getLinks("filteredItems").input(sort.item.getType("sorted").idsSource);
		
		
		let copyValue = this._elementTreeItem.addNode("copyValue", new Wprr.utils.data.nodes.CopyValue());
		copyValue.sources.get("active").input(this._elementTreeItem.getValueSource("loaded"));
		copyValue.sources.get("input").input(detailsLoader.item.getLinks("loadedIds"));
		
		this._elementTreeItem.getLinks("items").idsSource.input(copyValue.sources.get("output"));
		loader.setUrl(this.getWprrUrl("range/?select=byObjectType,includePrivate,includeDraft&encode=id&type=product/mix", "wprrData"));
		
		let table = this._elementTreeItem.addNode("table", new Wprr.utils.data.multitypeitems.itemstable.ItemsTable());
		
		{
			let column = table.createColumn("select", "Select/Id").setCellClasses("select-id-cell-width");
			column.setElement(<div>
				<Wprr.FlexRow className="micro-item-spacing vertically-center-items">
					<Wprr.Checkbox checked={Wprr.sourceReference("row", "active")} />
					<div className="standard-flag standard-flag-padding id-flag">{Wprr.text(Wprr.sourceReference("item", "id"))}</div>
				</Wprr.FlexRow>
				<Wprr.AddReference data={Wprr.sourceReference("itemEditor", "postStatusEditor")} as="valueEditor">
					<div className="spacing micro" />
					<Wprr.HasData check={Wprr.sourceReference("valueEditor", "valueSource")} checkType="equal" compareValue="draft">
						<Wprr.FlexRow>
							<div className="standard-flag standard-flag-padding status-flag draft">{Wprr.idText("Draft", "site.admin.draft")}</div>
						</Wprr.FlexRow>
					</Wprr.HasData>
				</Wprr.AddReference>
			</div>);
			column.setHeaderElement(<div />);
		}

		{
			let column = table.createColumn("name", "Name");
			column.setElement(<div>{Wprr.text(Wprr.sourceReference("item", "title"))}</div>);
		}
		
		{
			let column = table.createColumn("bulls", "Bulls");
			column.setElement(<Wprr.layout.admin.editorsgroup.editors.SelectRelations direction="outgoing" relationType="of" objectType="bull" allowCreation={false} />);
		}
		
		let batchEditItem = this._elementTreeItem.group.getItem("batchEdit/product/mixs");
		
		{
			let noneItem = this._elementTreeItem.group.createInternalItem();
			noneItem.setValue("name", "None");
			noneItem.setValue("selectedLabel", "Select operation");
			batchEditItem.getLinks("batchActions").addItem(noneItem.id);
		}
	}

	_add() {
		let project = this.getFirstInput(Wprr.sourceReference("wprr/project"));
		
		let loader = project.getCreateLoader("page", "product/mix");
		
		loader.changeData.addTerm("product", "dbm_type", "slugPath");
		
		loader.changeData.setTitle("New product/mix");
		loader.changeData.setStatus("publish");
		
		loader.addSuccessCommand(Wprr.commands.callFunction(this, this._added, [Wprr.sourceEvent("data.id")]));
		
		loader.load();
	}
	
	_added(aId) {
		let loader = this._elementTreeItem.createNode("loader" + aId, "loadDataRange");
		loader.item.getLinks("items").idsSource.addChangeCommand(Wprr.commands.callFunction(this, this._initalDataLoaded, [aId]));
		loader.setUrl(this.getWprrUrl("range/?select=idSelection,anyStatus&encode=fields,postStatus,postTitle&ids=" + aId, "wprrData"));
	}
	
	_initalDataLoaded(aId) {
		this._elementTreeItem.getLinks("items").addItem(aId);
	}
	
	_renderMainElement() {
		
		
		return <div>
			<Wprr.AddReference data={this._elementTreeItem} as="editorItem">
			<Wprr.layout.admin.editorsgroup.editors.EditorsGroup>
				<Wprr.layout.admin.editorsgroup.SaveAllGroup>
					<Wprr.AddReference data={Wprr.sourceStatic(this._elementTreeItem, "table.linkedItem")} as="table">
						<Wprr.FlexRow className="justify-between">
							<div>
								<h2 className="no-margins">{Wprr.idText("Mix products", "site.mixProducts")}</h2>
								<div className="operations">
									<Wprr.SelectItem id="batchEdit/product/mixs" as="batchEdit">
										<div>
											<Wprr.FlexRow className="micro-item-spacing">
												{Wprr.DropdownSelection.createSelfContained(
													React.createElement(Wprr.layout.form.DropdownButton, {
														"className": "cursor-pointer batch-operations-text batch-operations-select-title",
														"text": Wprr.sourceFirst(
															Wprr.sourceReference("editorItem", "operation.linkedItem.selectedLabel"),
															Wprr.sourceReference("editorItem", "operation.linkedItem.title"),
															Wprr.sourceTranslation("Select operation", "site.admin.selectOperation")
														),
														"sourceUpdates": Wprr.sourceReference("editorItem", "operation.idSource")
													}),
													<div className="custom-selection-container custom-selection-menu">
														<Wprr.layout.ItemList ids={Wprr.sourceReference("batchEdit", "batchActions.idsSource")}>
															<Wprr.CommandButton commands={[
																Wprr.commands.setProperty(Wprr.sourceReference("editorItem", "operation"), "id", Wprr.sourceReference("item", "id")),
																Wprr.commands.setValue(Wprr.sourceReference("value/open"), "open", false)
															]}>
																<div className="hover-row standard-row standard-row-padding cursor-pointer">{Wprr.text(Wprr.sourceReference("item", "name"))}</div>
															</Wprr.CommandButton>
														</Wprr.layout.ItemList>
													</div>,
													{ className: "absolute-container" }
												)}
												<Wprr.HasData check={Wprr.sourceReference("editorItem", "selectedItems.idsSource")} checkType="notEmpty">
													<Wprr.FlexRow className="micro-item-spacing batch-operations-text">
														<div>for</div>
														<Wprr.layout.ListWithOthers items={Wprr.sourceReference("editorItem", "selectedItems.items")} nameField="title.value" sourceUpdates={Wprr.sourceReference("editorItem", "selectedItems.idsSource")} showNumberOfItems={2} />
													</Wprr.FlexRow>
												</Wprr.HasData>
											</Wprr.FlexRow>
										</div>
									</Wprr.SelectItem>
								</div>
							</div>
							<div>
								<Wprr.FlexRow className="small-item-spacing">
									<Wprr.FormField value={Wprr.sourceReference("editorItem", "searchFilter.linkedItem.searchValue")} />
									<Wprr.layout.form.MoreOptionsDropdown className="dropdown-from-right">
										<div className="custom-selection-menu-padding">
											<Wprr.layout.ItemList ids={Wprr.sourceReference("table", "activeList.linkedItem.rows.idsSource")}>
												<div>
													<Wprr.FlexRow className="micro-item-spacing vertically-center-items">
														<Wprr.Checkbox checked={Wprr.sourceReference("item", "active")} />
														{Wprr.text(Wprr.sourceReference("item", "forItem.linkedItem.title"))}
													</Wprr.FlexRow>
												</div>
											</Wprr.layout.ItemList>
										</div>
									</Wprr.layout.form.MoreOptionsDropdown>
								</Wprr.FlexRow>
							</div>
						</Wprr.FlexRow>
						<div className="spacing medium" />
						<Wprr.RelatedItem id="operation.linkedItem" from={Wprr.sourceReference("editorItem")} as="batchActionItem" sourceUpdates={Wprr.sourceReference("editorItem", "operation.idSource")}>
							<Wprr.InsertElement element={Wprr.sourceReference("batchActionItem", "element")} canBeEmpty={true} />
						</Wprr.RelatedItem>
						<div className="spacing medium" />
						<Wprr.HasData check={this._elementTreeItem.getValueSource("loaded")}>
							<React.Fragment>
								<Wprr.InsertElement element={Wprr.sourceReference("table", "headerRowElement")} />
								<Wprr.layout.ItemList ids={this._elementTreeItem.getLinks("filteredItems").idsSource} as="row">
									<Wprr.RelatedItem id="forItem.linkedItem" from={Wprr.sourceReference("row")} as="item">
										<Wprr.layout.loader.DataRangeLoader path={Wprr.sourceCombine("range/?select=idSelection,anyStatus&encode=relations&ids=", Wprr.sourceReference("item", "id"))} as="itemLoader">
											<Wprr.AddReference data={Wprr.sourceFunction(Wprr.sourceReference("editorsGroup"), "getItemEditor", [Wprr.sourceReference("item", "id")])} as="itemEditor">
												<Wprr.InsertElement element={Wprr.sourceReference("table", "rowElement")} />
											</Wprr.AddReference>
										</Wprr.layout.loader.DataRangeLoader>
									</Wprr.RelatedItem>
									<div className="spacing medium" data-slot="spacing" />
								</Wprr.layout.ItemList>
								
							</React.Fragment>
						</Wprr.HasData>
						<Wprr.HasData check={this._elementTreeItem.getValueSource("loaded")} checkType="invert/default">
							<Wprr.layout.loader.LoaderDisplay />
						</Wprr.HasData>
						<div className="spacing standard" />
								<Wprr.FlexRow>
									<Wprr.layout.interaction.Button text={Wprr.sourceTranslation("Add", "site.add")} commands={Wprr.commands.callFunction(this, this._add, [])} className="add-button add-button-padding cursor-pointer" />
								</Wprr.FlexRow>
					</Wprr.AddReference>
				</Wprr.layout.admin.editorsgroup.SaveAllGroup>
			</Wprr.layout.admin.editorsgroup.editors.EditorsGroup>
		
			</Wprr.AddReference>
		</div>;
	}
	
	static getWpAdminEditor() {
		console.log("getWpAdminEditor");
		
		let dataSettings = {
			
		};
		
		return <Wprr.layout.admin.WpBlockEditor dataSettings={dataSettings}>
			
		</Wprr.layout.admin.WpBlockEditor>
	}
}
